import React, { useEffect, useState } from "react";
import SelectField from "../../../../../genericInputFields/selectLabeled/selectLabeled.component";
import useAppContext from "../../../../../../hooks/useAppContext";
import Field, {
  TYPES,
} from "../../../../formComponents/formFields/field.component";
import { useWatch, useFormContext } from "react-hook-form";
import Checkbox from "../../../../../genericInputFields/checkbox/checkbox.component";

const LocationCriteria = ({ settings = {}, name, values = [] }) => {
  const { axios } = useAppContext();
  const { optionsFetchFrom } = settings;
  const [locations, setLocations] = useState([]);
  const [selectedContinent, setSelectedContinent] = useState(null);
  const watchCheckboxes = useWatch({ name });
  const { setValue } = useFormContext();

  useEffect(() => {
    const handleLocations = (locData) => {
      setLocations(locData);
      const findContinent = locData.find((el) =>
        values.every((itm) => el.items.map((item) => item.value).includes(itm)),
      );
      if (findContinent) setSelectedContinent(findContinent);
    };
    const { url, cacheKey } = optionsFetchFrom;
    const cachedItems = sessionStorage.getItem(cacheKey);
    if (cachedItems) handleLocations(JSON.parse(cachedItems));
    else {
      axios.get(url).then((resp) => {
        const locationData = resp.data.data;
        handleLocations(locationData);
        sessionStorage.setItem(cacheKey, JSON.stringify(locationData));
      });
    }
  }, []);

  const onSelectAll = (e) => {
    if (e.target.checked) {
      setValue(
        name,
        selectedContinent?.items?.map((item) => item.value),
      );
    } else {
      setValue(name, []);
    }
  };

  const onContinentChange = (e) => {
    setSelectedContinent(locations.find((item) => item.value === e));
    setValue(name, []);
  };

  return (
    <>
      <SelectField
        useInForm={false}
        onChange={onContinentChange}
        name="continent"
        options={locations}
        placeholder="Select continent"
        initialValue={selectedContinent?.value}
      />
      {selectedContinent && (
        <>
          <Checkbox
            value="select_all"
            label={watchCheckboxes?.length ? "Unselect all" : "Select all"}
            checked={watchCheckboxes?.length}
            onChange={onSelectAll}
          />
          <Field
            type={TYPES.CHECKBOX}
            name={name}
            options={selectedContinent?.items}
          />
        </>
      )}
    </>
  );
};

export default LocationCriteria;
